/** @file The timeline and animations panels' links out: command dispatch (E8) and compiled data (E1). */
import type { SkeletonData } from '@pose2d/core/types';
import type { CommandCall, Doc } from '@pose2d/format/types';
import { dispatch } from '../api/sync/dispatch';
import { compiledStore } from '../stores/compiledStore';
import { currentDoc } from '../stores/currentDoc';
import { docStore } from '../stores/docStore';

/** What the panels' actions need from the rest of the editor; tests pass fakes. */
export interface EditorDeps {
  /** Sends one batch (one undo step); an empty batch sends nothing; a refusal goes to `report`. */
  dispatch(calls: readonly CommandCall[]): void;
  /** The compiled skeleton of the open document, or null while there is none. */
  data(): SkeletonData | null;
  /** The working document (confirmed plus pending), or null while none is open. */
  doc(): Doc | null;
  /** Shows a failure in the panel (errorText). */
  report(thrown: unknown): void;
}

/** The real links; `report` is the panel's error setter. */
export function editorDeps(report: (thrown: unknown) => void): EditorDeps {
  return {
    dispatch: (calls) => {
      if (calls.length === 0) return;
      try {
        dispatch([...calls]).done.catch(report);
      } catch (thrown) {
        report(thrown);
      }
    },
    data: () => compiledStore.getState().data,
    doc: () => currentDoc(docStore.getState()),
    report,
  };
}
